/**
 * @file 官方合作伙伴
 * @author (chenyuyang@baidu.com)
 */

import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {fetchBusinessPartner} from '../../actions/partner';
import {bCat_2055_request} from '../../util';
import './index.less';

class Partner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            range: [],
            rangeChecked: '',
            dataList: []
        };
    }

    componentDidMount() {
        this.getBusinessPartner();
    }

    index = 0;
    getBusinessPartner = (area) => {
        const _fetchBusinessPartner = (params) => this.props.fetchBusinessPartner({
            area,
            ...params
        }).then((res) => {
            const {code, data} = res || {};
            if (code === 200) {
                this.setState({
                    range: data.areas,
                    rangeChecked: data.area,
                    dataList: data.ds || []
                });
            }
        });
        bCat_2055_request(_fetchBusinessPartner);
    };

    changeArea = (item) => {
        this.setState({
            rangeChecked: item
        }, () => {
            this.getBusinessPartner(item);
        });
    };

    jump = (type) => {
        switch (type) {
            case 'partner':
                this.props.history.push('/partner');
                break;
            default:
        }
    };

    render() {
        const {range, rangeChecked, dataList = []} = this.state;
        const dataListInfo = dataList.map((item) => {
            return (
                <div key={item.id} className="detail-list">
                    <div className="logo-wrapper">
                        <img className="logo" src={item.logo_url}></img>
                    </div>
                    <div className="list-wrapper">
                        <div className="list-title">{item.company_name}</div>
                        <div className="list-item">电话： {item.contact || '-'}</div>
                        <div className="list-item">E-mail： {item.email || '-'}</div>
                        <div className="list-item">地址：{item.address || '-'}</div>
                    </div>
                </div>
            );
        });
        return (
            <div className="page-partner">
                <div className="nav-title">
                    <span className="pre-title">常见问题</span>
                    <span className="br">|</span>
                    <span className="title">官方合作伙伴</span>
                </div>
                <div className="content">
                    <div className="content-header">
                        <div className="content-title">官方合作伙伴</div>
                        <div className="content-tip">百度安全号码认证平台官方合作伙伴，为各区域的企业提供号码认证等服务支持。</div>
                    </div>
                    <div className="info">
                        <div className="area">
                            {range.length > 0 && range.map((item) => {
                                return (
                                    <div
                                        key={item}
                                        className={`area-list ${item === rangeChecked ? 'checked' : ''}`}
                                        onClick={() => {this.changeArea(item);}}
                                    >{item}</div>
                                );
                            })}
                        </div>
                        <div className="detail">
                            {dataList.length > 0 ? dataListInfo : <div className="empty">当前区域暂无合作伙伴</div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Partner.propTypes = {
    history: PropTypes.object,
    fetchBusinessPartner: PropTypes.func,
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchBusinessPartner: obj => fetchBusinessPartner(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Partner));